import HistoryLayout from '@/routes/account/layout/HistoryLayout';
import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

interface TravelPassesProps {}

const TravelPasses: FC<TravelPassesProps> = () => {
  return (
    <HistoryLayout bookingType="travelPasses">
      <Outlet />
    </HistoryLayout>
  );
};

export default TravelPasses;
